import { BLACK, WHITE } from './black-and-white'
import type { Color } from './color'

/**
 * According to Claude:
 *
 * The threshold of 0.179 provides good contrast ratios that meet accessibility
 * standards. This approach ensures readable text regardless of the background
 * color by maximizing the contrast between text and background.
 */
const LUMINANCE_THRESHOLD_FOR_DARK_FONT = 0.179

/**
 * Determines accessibility-friendly font {@link Color} based on the given
 * background {@link Color}
 */
// NOTE: this function was generated by Claude
export function font(background: Color): Color {
  // Remove # if present and convert to lowercase
  const hex = background.replace('#', '').toLowerCase()

  // Parse RGB values from hex
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  // Calculate relative luminance using the WCAG formula
  // Convert RGB to linear RGB first
  const toLinear = (c: number) => {
    const normalized = c / 255
    return normalized <= 0.03928
      ? normalized / 12.92
      : Math.pow((normalized + 0.055) / 1.055, 2.4)
  }

  const rLinear = toLinear(r)
  const gLinear = toLinear(g)
  const bLinear = toLinear(b)

  // Calculate luminance
  const luminance = 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear

  // Return white for dark backgrounds, black for light backgrounds
  return luminance > LUMINANCE_THRESHOLD_FOR_DARK_FONT ? BLACK : WHITE
}
